import request from '@/utils/request'

let Recomm_awardApi = {

  /*推荐奖列表*/
  list(data) {
    return request._post('/shop/plus.recomm_award.Index/index', data);
},
  gradelist(data) {
    return request._post('/shop/plus.recomm_award.Index/gradelist', data);
},
/*添加推荐奖*/
add(data) {
    return request._post('/shop/plus.recomm_award.Index/add', data);
},
/*修改推荐奖*/
edit(data) {
    return request._post('/shop/plus.recomm_award.Index/edit', data);
},
/*删除推荐奖*/
del(data) {
    return request._post('/shop/plus.recomm_award.Index/del', data);
},
/*推荐奖详情*/
detail(data) {
  return request._post('/shop/plus.recomm_award.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.recomm_award.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.recomm_award.Setting/getSetting', data, errorback);
    },

     saveSettings(data, errorback) {
        return request._post('/shop/plus.recomm_award.Setting/getSettings', data, errorback);
    },
    getSettings(data, errorback) {
        return request._get('/shop/plus.recomm_award.Setting/getSettings', data, errorback);
    },
}
export default Recomm_awardApi;



// WEBPACK FOOTER //
// ./src/api/recomm_award.js